import { formatName } from 'helpers/utils'
import { useState } from 'preact/hooks'

function CheckboxInput({
  classWrap,
  name,
  value,
  label,
  checked,
  index,
  onSelected,
  classInput = '',
  classLabel = ''
}) {
  const [isChecked, setIsChecked] = useState(checked)

  const handleSelected = (newValue) => {
    setIsChecked(!isChecked)
    onSelected && onSelected(newValue, !checked)
  }

  return (
    <div key={value} className={`checkbox-input relative flex items-center ${classWrap}`}>
      <input
        id={`${value}-${index}`}
        className={`checkbox-input__input ${classInput}`}
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onInput={() => handleSelected(value)}
      />
      <label htmlFor={`${value}-${index}`} className={`checkbox-input__label ${classLabel}`}>
        {formatName(label)}
      </label>
    </div>
  )
}

export default CheckboxInput
